import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import type { Props as BadgeProps } from '@/core/components/base/indicator/Badge.vue'; 
import type { Props as SvgThemedIconProps } from '@/core/components/base/image/SvgThemedIcon.vue';
import type { DefineComponent } from 'vue';
import type { Props as BaseLinkMenuProps } from '@/core/components/base/link/Menu.vue';

interface Props {
    linkTag?: string | DefineComponent,
    linkTagProps?: BaseLinkMenuProps,
    theme?: 'light' | 'dark',
    prefixIcon?: SvgThemedIconProps,
    prefixIconActive?: SvgThemedIconProps,
    suffixIcon?: SvgThemedIconProps,
    suffixIconActive?: SvgThemedIconProps,
    title?: string,
    badgeProps?: BadgeProps,
    value?: boolean,
    to?: string,
    disabled?: boolean,
    active?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Collapsible',
  props: {
    linkTag: null,
    linkTagProps: { default: () => ({}) },
    theme: null,
    prefixIcon: null,
    prefixIconActive: null,
    suffixIcon: null,
    suffixIconActive: null,
    title: null,
    badgeProps: null,
    value: { type: Boolean },
    to: null,
    disabled: { type: Boolean },
    active: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as { linkTag?: string | DefineComponent, linkTagProps: BaseLinkMenuProps, theme?: 'light' | 'dark', prefixIcon?: SvgThemedIconProps, prefixIconActive?: SvgThemedIconProps, suffixIcon?: SvgThemedIconProps, suffixIconActive?: SvgThemedIconProps, title?: string, badgeProps?: BadgeProps, value?: boolean, to?: string, disabled?: boolean, active?: boolean };

;





const {
    theme,
    prefixIcon,
    prefixIconActive,
    suffixIcon,
    suffixIconActive,
    title,
    badgeProps,
    value,
    to,
    disabled,
    active,
    linkTag,
    linkTagProps,
} = toRefs(props);

return { __sfc: true,props, theme, prefixIcon, prefixIconActive, suffixIcon, suffixIconActive, title, badgeProps, value, to, disabled, active, linkTag, linkTagProps }
}

})